// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vDjU","question":"styles_question__nsYzp","description":"styles_description__OMuBQ"};